import "./paymentmethod.scss"
import * as React from "react";
import Radio from "@mui/material/Radio";
import HorizontalDivider from "../horizontaldivider/horizontaldivider";

interface IPaymentMethod {
    money:string
}

const PaymentMethod = ({money}:IPaymentMethod) => {
    const [selectedValue, setSelectedValue] = React.useState('W');
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedValue(event.target.value);
    };
    return (
        <div className="Payment-Method">
            <div className="Payment-Method-Right">
                <img src={require("../../assets/images/icons/Price.svg").default} alt="" className="img-fluid pt-1"/>
                <br/>
                <div className="pt-4">
                    <span>مبلغ قابل پرداخت :</span>
                    <p>{money} تومان</p>
                </div>
            </div>
            <div className="Payment-Method-Left">
                <div className="d-flex justify-content-between w-100 align-items-center">
                    <div style={{cursor: 'pointer'}} onClick={() => setSelectedValue("W")}>
                        <img src={require("../../assets/images/icons/Wallet.svg").default} alt="" className="img-fluid"/>
                        <span>کیف پول</span>
                    </div>
                    <Radio
                        checked={selectedValue === 'W'}
                        onChange={handleChange}
                        value="W"
                        name="radio-buttons"
                        inputProps={{'aria-label': 'W'}}
                    />
                </div>
                <HorizontalDivider />
                <div className="d-flex justify-content-between w-100 align-items-center">
                    <div style={{cursor: 'pointer'}} onClick={() => setSelectedValue("D")}>
                        <img src={require("../../assets/images/icons/Wallet.svg").default} alt="" className="img-fluid"/>
                        <span>پرداخت مستقیم</span>
                    </div>
                    <Radio
                        checked={selectedValue === 'D'}
                        onChange={handleChange}
                        value="D"
                        name="radio-buttons"
                        inputProps={{'aria-label': 'D'}}
                    />
                </div>
            </div>
        </div>
    );
}

export default PaymentMethod;